import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ManageUserViewUserList } from './userApi.types';
import { User } from '../../types/user/user';

export interface OrganizationEntry {
  id: number;
  name: string;
}
export type OrganizationList = Array<{ organization: OrganizationEntry }>;

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  baseUrl = '/aptitude/api';

  securedBaseUrl = '/aptitude/api/useraccount';

  constructor(private http: HttpClient) {}

  findUsers(roles: Array<string>, type = 'buyer', excludeMe = true) {
    return this.http.post(
      `/aptitude/${type}/ManageUserViewServiceController/findUsers`,
      {
        roles,
        excludeMe,
      },
    ) as Observable<ManageUserViewUserList>;
  }

  findBuyersWhoCanReviewContracts() {
    return this.findUsers(['ROLE_BUYER_PURCHASE_PLAN_EDIT']);
  }

  findBuyersWhoCanSignContracts() {
    return this.findUsers(['ROLE_BUYER_CPA_EXECUTE']);
  }

  findSellersWhoCanReviewContracts() {
    return this.findUsers([], 'seller');
  }

  findSellersWhoCanSignContracts() {
    return this.findUsers(['ROLE_SELLER_CPA_EXECUTE'], 'seller');
  }

  getLoggedInUser(): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}/users/me/account`);
  }

  /**
   * Call this for authenticated users to reset the password
   */
  authenticatedResetPassword(email: string) {
    return this.http.post(`${this.securedBaseUrl}/passwordresetrequests/`, {
      email,
    });
  }

  clearCookies() {
    return this.http.post(
      `/aptitude/auth/clear-cookies`,
      {},
      { headers: { 'Skip-Auth': 'true' } },
    );
  }

  termsAndConditionsRequests(acceptTermsAndConditions: boolean) {
    return this.http.post(`${this.securedBaseUrl}/termsandconditionsrequests`, {
      acceptTermsAndConditions,
    });
  }

  organizations(userId: number | string) {
    return this.http.get<OrganizationList>(
      `/aptitude/api/users/${userId}/organizations`,
    );
  }

  switchAccount(userId: number | string, orgId: number) {
    return this.http.put<{ idToken: string }>(
      `/aptitude/api/users/${userId}/account`,
      {
        organization: {
          id: orgId,
        },
      },
    );
  }
}
